<mat-toolbar [color]="menuColor ?? 'primary'" class="toolbar-variant">
  <mat-toolbar-row>
    <div class="menu-icon">
      <button mat-icon-button (click)="onToggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div *ngIf="!!logoSrc" class="logo">
      <img src={{logoSrc}} alt="Logo">
    </div>
    <h1>{{title}}</h1>
    <span class="spacer"></span>
    <div class="menu-items">
      <ng-container *ngFor="let item of (menu$ | async)">
        <a mat-button [routerLink]="item.route">{{item.label | translate}}</a>
      </ng-container>
    </div>
    <button mat-icon-button [matMenuTriggerFor]="languagemenu" *ngIf="!!languages[selectedLang]">
      <span class="flag-icon flag-icon-{{languages[selectedLang].flag}} flag-icon-squared fi fi-{{languages[selectedLang].flag}} fis"></span>
    </button>
    <mat-menu #languagemenu="matMenu">
      <ng-container *ngFor="let lang of availableLanguages">
        <button mat-menu-item (click)="setLanguage(lang)" *ngIf="!!languages[lang]">
          <span class="flag-icon flag-icon-{{languages[lang].flag}} flag-icon-squared"></span>
          <span> {{languages[lang].name}}</span>
        </button>
      </ng-container>
    </mat-menu>
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>person</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <ng-container *ngFor="let extra of extraOptions">
        <button mat-menu-item (click)="select(extra.option)">
          <mat-icon>{{extra.icon}}</mat-icon>
          <span>{{ extra.label | translate }}</span>
        </button>
      </ng-container>
      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>{{ 'labels.logout' | translate }}</span>
      </button>
    </mat-menu>
    <button mat-icon-button (click)="help()">
        <mat-icon>contact_support</mat-icon>
    </button>
  </mat-toolbar-row>
</mat-toolbar>